import { render, staticRenderFns } from "./menu-side.vue?vue&type=template&id=fb99a2e0"
import script from "./menu-side.vue?vue&type=script&lang=js"
export * from "./menu-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports